import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { saveCartId } from "../../features/Cart/CartSlice";
import DEFAULT_OPERATIONS from "../CartPage/Cart.gql";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveUserToken } from "../../features/login/LoginSlice";

export const useCreateCart = () => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const dispatch = useDispatch();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const customer_type = params.get("customer_type");
  const isCartId = params.get("cart_id");
  const secret = params.get("secret");
  const customer_email = params.get("customer_email");
  const { cartId } = useSelector((state) => state.cartSlice);
  const {
    createCartMutation,
    createCartAfterSignInMutation,
    updateEmailOpenStatus,
    generateCustomerTokenWithKey,
  } = DEFAULT_OPERATIONS;

  const [CreateEmptyCart, { data }] = useMutation(createCartMutation, {
    onCompleted: (data) => {
      dispatch(saveCartId(data.cartId));
    },
  });
  const [GenerateCustomerTokenWithKey] = useMutation(
    generateCustomerTokenWithKey
  );

  const [UpdateEmailOpenStatus] = useMutation(updateEmailOpenStatus, {
    variables: {
      uid: secret,
    },
  });

  const [CreateEmptyCartAfterSignIn, { data: createEmptyCartAfterSignIn }] =
    useMutation(createCartAfterSignInMutation, {
      onCompleted: (data) => {
        dispatch(saveCartId(data.cartId));
      },
    });

  useEffect(() => {
    if ((!cartId || cartId.trim() === "") && !customer_type) {
      if (isSignedIn) {
        CreateEmptyCartAfterSignIn();
      } else {
        CreateEmptyCart();
      }
    }
  }, [cartId, customer_type, isSignedIn]);

  useEffect(() => {
    const alreadyCalled = sessionStorage.getItem("emailOpenStatusUpdated");
    const hasRun = sessionStorage.getItem("hasHandledCart");

    if (customer_type) {
      if (!alreadyCalled) {
        UpdateEmailOpenStatus();
        sessionStorage.setItem("emailOpenStatusUpdated", "true");
      }

      const handleCart = async () => {
        if (hasRun) return;

        if (customer_type === "guest" && isCartId) {
          dispatch(saveCartId(isCartId));
          sessionStorage.setItem("hasHandledCart", "true");
        } else if (customer_type === "registered" && isCartId) {
          sessionStorage.setItem("hasHandledCart", "true");
          try {
            const signInResponse = await GenerateCustomerTokenWithKey({
              variables: { email: customer_email, secret },
            });
            const token =
              signInResponse.data.generateCustomerTokenWithKey.token;
            dispatch(saveCartId(isCartId));
            dispatch(saveUserToken(token));
          } catch (error) {
            console.error("Error generating customer token:", error);
          }
        }
      };

      handleCart();
    }
  }, [customer_type]);

  return {
    data,
    CreateEmptyCart,
    CreateEmptyCartAfterSignIn,
  };
};
